export const INITIALIZE_CHECKOUT = 'initialize-checkout';

const initializeCheckout = ({ quoteId, locationId }) => (
  { type: INITIALIZE_CHECKOUT, payload: { quoteId, locationId } }
);
export default initializeCheckout;
